import React, { Component,useState } from 'react';
import Button from '@mui/material/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../../index.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import * as apiDashBoardService from '../../NewProcess/apiRequestService';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import PendingIcon from '@mui/icons-material/Pending';
import Moment from 'moment';
import {getApprovalDetail} from '../../NewProcess/apiRequestService';
import Alert from '@mui/material/Alert';
import styles from '../style.js';
import Stepper from '../../ui/Stepper';
import SignVerifyDialog from './SignVerifyDialog';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {DownloadFile, DownloadZipFile} from '../../../utils/fileOperation';
import PropTypes from 'prop-types';

class DetailPage extends Component {
 

  constructor(props) {
    super(props);
    this.state = {
      BoxClass:{
        boxShadow: 12
      },
      processInfos:[],
      processDetails:[],
      processSigners:[],
      selectedValue:{},
      cancelReason:"",
      steps : [
        'Süreç Başlangıcı',
        'Süreç Onayları',
        'Süreç Sonucu',
      ],
      activeStep:3,
      isDialogOpen:false,
      verifyInfos:[]
    };
  }

  componentDidMount() {
    const {selectedId}=this.props;

    getApprovalDetail(selectedId)
    .then((response) => {
        this.setState({selectedValue: response.data}, () => {this.fillPageDetails();});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Detay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getApprovalDetail exception: ' + JSON.stringify(exception));
    });
  }

  fillPageDetails() {  
    const{selectedValue}=this.state;

    let rows = [
      {name:"Süreç Adı",detail:selectedValue.name},
      {name:"Süreç Grubu",detail:!_.isNil(selectedValue.processTypeDetail) && !_.isNil(selectedValue.processTypeDetail.processGroup)?
      selectedValue.processTypeDetail.processGroup.name:''},
      {name:"Süreç Türü",detail:!_.isNil(selectedValue.processTypeDetail)?selectedValue.processTypeDetail.processTypeName:''},
      {name:"İmzalama Sırası",detail:selectedValue.signOrderTitle}, 
      {name:"Süreç Sonu Eylemi",detail:selectedValue.endOperationActionTitle}
    ]
    this.setState({processInfos:rows});

    let detailRows = [
      {name:"Süreç Bilgilendirme",detail:selectedValue.notificationTypeTitle},
      {name:"Süreç Sonu Bilgilendirme",detail:selectedValue.endProcessNotificationTypeTitle},
      {name:"Süreç Kayıt Tarihi",detail:Moment(selectedValue.createdDate).format('DD/MM/YYYY HH:mm')},
      {name:"Süreç Oluşturan",detail:selectedValue.createdUser},
      {name:"Dosya Adı",detail:selectedValue.approvalFile.fileName}]
    this.setState({processDetails:detailRows});

    if (!_.isNil(selectedValue.internalSigners)) {
      let signerRows = [];
      for (const element of selectedValue.internalSigners) {
        let value=element;
        signerRows.push({
          name:value.userInfo.name,
          detail:value.signType.parameterName,
          recordStatus:value.recordStatus,
          updateDate:value.lastUpdatedDate});
      }
      this.setState({processSigners:signerRows});
    }
  }

  handleViewDoc = () => {
    const { selectedValue } = this.state;
  
    Promise.all([
      apiDashBoardService.getSignedFile(selectedValue.id),
      apiDashBoardService.getApprovalFile(selectedValue.id),
      apiDashBoardService.getAdditionalFile(selectedValue.id),
    ])
      .then(([signedFileResponse, approvalFileResponse, additionalFileResponse]) => {
        const signedFile = signedFileResponse.data;
        const approvalFile = approvalFileResponse.data;
        const additionalFile = additionalFileResponse.data;
  
        if (!approvalFile) {
          throw new Error("Süreç dokümanı bulunamadı.");
        }
  
        const filesToDownload = [];
  
        // Tip bilgilerini ekleyerek DownloadZipFile'a uygun hale getir
        if (signedFile)
          filesToDownload.push({
            fileData: signedFile.fileData,
            fileName: signedFile.fileName,
            type: "signed",
          });
  
        filesToDownload.push({
          fileData: approvalFile.fileData,
          fileName: approvalFile.fileName,
          type: "approval",
        });
  
        if (additionalFile)
          filesToDownload.push({
            fileData: additionalFile.fileData,
            fileName: additionalFile.fileName,
            type: "additional",
          });
  
        if (filesToDownload.length === 1) {
          const file = filesToDownload[0];
          DownloadFile(file.fileData, file.fileName);
        } else {
          DownloadZipFile(filesToDownload);
        }
      })
      .catch((exception) => {
        this.props.actions.setNotification("Dosya bilgileri getirilemedi, daha sonra tekrar deneyin.", "error");
        console.log('handleViewDoc exception: ' + JSON.stringify(exception));
      });
  };

  handleSignVerify=()=>{
    const{selectedValue}=this.state;
    
    apiDashBoardService.verifyApprovalFile(selectedValue.id)
    .then((response) => {
      let signersList=[];
      const verifications=response.data;
      for (let i = 0; i < verifications.length; i++) {
        const verification = verifications[i];

        let signerInfos=[];
        if(!_.isNil(verification.signer) && verification.signer.length>0){
          const signer = verification.signer[0];
          signerInfos = [
            {name:"Ad Soyad",detail:signer.commonName},
            {name:"TCKN",detail:signer.serialNumber}
            ];
        

          let resulDetails=[];
          if(!_.isNil(verification.verificationResults) && verification.verificationResults.length>0){
            for (const element of verification.verificationResults) {
              const result = element;
              resulDetails.push({detail:result.message});
            }
          }
          
          signersList.push({id:i+1,name:signer.commonName,signerInfos:signerInfos,resulList:resulDetails})
        }
      }
      this.setState({verifyInfos:signersList,isDialogOpen:true});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Dosya bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('handleSignVerify exception: ' + JSON.stringify(exception));
    });
  }

  handleCloseDialog(ele) {
    this.setState({ isDialogOpen: false });
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  getUserIcon(recordStatus) {
    switch (recordStatus) {
      case "O":
        return (<TableCell sx={{width:"10%"}}><ThumbUpAltIcon sx={{color: "#57853f",fontSize: 30}}/></TableCell>);
      case "R":
        return (<TableCell sx={{width:"10%"}}><ThumbDownIcon sx={{color: "#ab3c3c",fontSize: 30}}/></TableCell>);
      default:
        return (<TableCell sx={{width:"10%"}}><PendingIcon sx={{color: "#ff8d00",fontSize: 30}}/></TableCell>);
    }
  }

  getUserApproveText(recordStatus,updateDate) {
    switch (recordStatus) {
      case "O":
        return (<TableCell><div style={styles.approveText}>Onaylandı</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      case "R":
        return (<TableCell><div style={styles.rejectText}>Reddedildi</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      default:
        return (<TableCell><div style={styles.pendingText}>Bekliyor</div></TableCell>);
    }
  }

  render() {
    const { BoxClass,processInfos,processDetails,processSigners,steps,activeStep} = this.state;

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
      }));

    return (
      <div>
        <Box sx={{ width: '100%' }}>
        <Stepper steps={steps} activeStep={activeStep} stepType={'completed'}/>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İçeriği</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processInfos.map((row) => (
                      <StyledTableRow key={row.id}>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              <div className="component">
                <Alert variant="filled" severity="success" style={styles.successAlert}>Süreç Tamamlandı</Alert>
                {/* <div>This is a success alert — check it out!</div> */}
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
                <div className='sameLine' style={{ width: '30%'}}>
                  <Button onClick={this.handleViewDoc}  style={styles.button} sx={{backgroundColor: '#386c99'}} variant="contained" >
                    Dosya İndir
                  </Button>
                </div>
                <div className='sameLine' style={{ width: '30%'}}>
                  <Button onClick={this.handleSignVerify}  style={styles.button} sx={{backgroundColor: '#90689d'}} variant="contained" >
                    Doğrulama Raporu Al
                  </Button>
                </div>           
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İmzacıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processSigners.map((row) => (
                      <StyledTableRow key={row.id}>
                        {this.getUserIcon(row.recordStatus)}
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                        {this.getUserApproveText(row.recordStatus,row.updateDate)}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç Ayrıntıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processDetails.map((row) => (
                      <StyledTableRow key={row.id}>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

        </Grid>
        </Box>
        <div>
        <SignVerifyDialog open = {this.state.isDialogOpen} verifyInfos={this.state.verifyInfos}
            onClose = {(e) => this.handleCloseDialog(e)} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

DetailPage.propTypes = {
  actions: PropTypes.shape({
    setNotification: PropTypes.func
  })
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(DetailPage);